if (!customElements.get('bioluma-compare')) {
  customElements.define(
    'bioluma-compare',
    class BiolumaCompare extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.parallax = this.querySelector('[data-compare-parallax]');
        this.img = this.querySelector('.bioluma-compare__parallax-img');
        if (!this.parallax || !this.img) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.onScroll = this.onScroll.bind(this);
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                window.addEventListener('scroll', this.onScroll, { passive: true });
                this.onScroll();
              } else {
                window.removeEventListener('scroll', this.onScroll);
              }
            });
          },
          { threshold: 0 }
        );
        this.observer.observe(this.parallax);
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        this.observer?.disconnect();
      }

      onScroll() {
        const rect = this.parallax.getBoundingClientRect();
        const viewportHalf = document.documentElement.clientHeight / 2;
        const center = rect.height / 2 + rect.top;
        const raw = viewportHalf ? ((viewportHalf - center) * 65) / viewportHalf : 0;
        const clamped = Math.max(-100, Math.min(raw, 100));
        const offset = clamped / 2 + 50;
        this.img.style.setProperty('--parallax-scroll-offset', `${offset}%`);
      }
    }
  );
}
